import { KEYS } from "./keys";
import { request } from "../axios";
import { encodeQueryData, handleApiError } from "../helper";
import {
  IReferralCodeLookupResponse,
  IReferralCodeOwnersResponse,
  IReferralCodesResponse,
  IReferralStatsResponse,
  ITraderAllParams,
  ITraderAllResponse,
  ITraderDetailResponse,
  IUpsertTraderPayload,
  IReferralsGeneralStatsResponse,
} from "./types";

export async function getTraderDetail(address: string): Promise<ITraderDetailResponse> {
  try {
    const { data } = await request.get(`${KEYS.TRADERS_DETAIL(address)}`);
    return data;
  } catch (error) {
    throw handleApiError(error);
  }
}

export async function upsertTrader(payload: IUpsertTraderPayload): Promise<ITraderDetailResponse> {
  try {
    const { data } = await request.post(KEYS.TRADERS_NEW, payload);
    return data;
  } catch (error) {
    throw handleApiError(error);
  }
}

export async function getTraderAll(params: ITraderAllParams): Promise<ITraderAllResponse> {
  try {
    const payload = encodeQueryData(params);
    const { data } = await request.get(`${KEYS.TRADERS_ALL}?${payload}`);
    return data;
  } catch (error) {
    throw handleApiError(error);
  }
}

export async function getReferralsSummary(
  address: string,
  params: { chainId: number; includeDistributions?: boolean }
): Promise<IReferralStatsResponse> {
  try {
    const payload = encodeQueryData(params);
    const { data } = await request.get(`${KEYS.REFERRALS_SUMMARY(address)}?${payload}`);
    return data;
  } catch (error) {
    throw handleApiError(error);
  }
}

export async function getReferralsCodes(address: string, params: { chainId: number }): Promise<IReferralCodesResponse> {
  try {
    const payload = encodeQueryData(params);
    const { data } = await request.get(`${KEYS.REFERRALS_CODES(address)}?${payload}`);
    return data;
  } catch (error) {
    throw handleApiError(error);
  }
}

export async function getReferralCodeLookup(
  code: string,
  params: { chainId: number }
): Promise<IReferralCodeLookupResponse> {
  try {
    const payload = encodeQueryData(params);
    const { data } = await request.get(`${KEYS.REFERRALS_CODE_LOOKUP(code)}?${payload}`);
    return data;
  } catch (error) {
    throw handleApiError(error);
  }
}

export async function postReferralCodesOwners(payload: {
  chainId: number;
  codes: string[];
}): Promise<IReferralCodeOwnersResponse> {
  try {
    const { data } = await request.post(KEYS.REFERRALS_CODES_OWNERS, payload);
    return data;
  } catch (error) {
    throw handleApiError(error);
  }
}

export async function getReferralsStats(params: { chainId: number }): Promise<IReferralsGeneralStatsResponse> {
  try {
    const payload = encodeQueryData(params);
    const { data } = await request.get(`${KEYS.REFERRALS_STATS}?${payload}`);
    return data;
  } catch (error) {
    throw handleApiError(error);
  }
}
